import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { FaSearch } from 'react-icons/fa'

import { parseDates, SubmitButton } from '../../../../core/components'
import { useFilterBar } from '../../providers'
import { parseGuests, parseLocations } from '../../utils'
import { FilterSections, Pages } from '../../FilterBarTypes'

import { Divider } from '../Divider/Divider'
import { SelectButton } from '../SelectButton/SelectButton'

import './FilterControls.css'

export const FilterControls = () => {
  const { t } = useTranslation('filterBar')

  const {
    calendarRange,
    selectedFilter,
    selectedPath,
    ageCategoryCounts,
    selectedLocations,
    mode,
    tabs,
    ageCategories,
    locations,
    innerLoading,
    outerLoading,
    handleSubmit,
    handleSelectedFilter,

    previouslyFocusedButtonRef,
    buttonRefs,
    tabsRef,
    filtersRef,
  } = useFilterBar()

  // Store previously focused button and restore focus when closing
  useEffect(() => {
    if (!selectedFilter && previouslyFocusedButtonRef.current) {
      previouslyFocusedButtonRef.current.focus()
      previouslyFocusedButtonRef.current = null
    }
  }, [selectedFilter])

  // Parsed data for filter section description
  const parsedDates = parseDates({ calendarRange })
  const parsedGuests = parseGuests({
    ageCategoryCounts,
    ageCategories,
    guestsPlaceholder: t('guests.labelPlaceholder'),
    guestLabel: t('guests.guestLabel'),
    guestsLabel: t('guests.guestsLabel'),
  })
  const parsedLocations = parseLocations({
    selectedLocations,
    locationsPlaceholder: t('locations.placeholder'),
    locationsSelectedLabel: t('locations.selected'),
  })

  return (
    <div
      className={`will-filter-bar-controls ${mode || 'light'} ${selectedFilter ? 'disabled' : ''}`}
      ref={(el) => {
        filtersRef.current = el

        if (tabs?.length === 1) {
          tabsRef.current = el
        }
      }}
    >
      {!!locations?.data?.length && locations.data.length > 1 && (
        <>
          <SelectButton
            ref={(el) => (buttonRefs.current[FilterSections.LOCATIONS] = el)}
            label={t('locations.label')}
            description={parsedLocations}
            onClick={(e) => {
              previouslyFocusedButtonRef.current = e.currentTarget
              handleSelectedFilter(FilterSections.LOCATIONS)
            }}
            active={!!selectedLocations.length}
            disabled={locations?.disabled}
            ariaExpanded={selectedFilter === FilterSections.LOCATIONS}
            ariaControls="will-filter-bar-locations"
          />

          <Divider />
        </>
      )}

      <SelectButton
        ref={(el) => (buttonRefs.current[FilterSections.CALENDAR] = el)}
        label={t('calendar.label')}
        description={
          parsedDates
            ? parsedDates
            : selectedPath === Pages.ROOMS
              ? t('calendar.roomsLabelPlaceholder')
              : t('calendar.eventsLabelPlaceholder')
        }
        onClick={(e) => {
          previouslyFocusedButtonRef.current = e.currentTarget
          handleSelectedFilter(FilterSections.CALENDAR)
        }}
        active={!!parsedDates}
        ariaExpanded={selectedFilter === FilterSections.CALENDAR}
        ariaControls="will-filter-bar-dates"
      />

      {selectedPath !== Pages.EVENTS && (
        <>
          <Divider />

          <SelectButton
            ref={(el) => (buttonRefs.current[FilterSections.GUESTS] = el)}
            label={t('guests.label')}
            description={parsedGuests.content}
            onClick={(e) => {
              previouslyFocusedButtonRef.current = e.currentTarget
              handleSelectedFilter(FilterSections.GUESTS)
            }}
            active={!!parsedGuests.data.total}
            ariaExpanded={selectedFilter === FilterSections.GUESTS}
            ariaControls="will-guests-filter"
          />
        </>
      )}

      <SubmitButton
        onClick={handleSubmit}
        startIcon={<FaSearch />}
        label={t('common:search')}
        isLoading={innerLoading || outerLoading}
      />
    </div>
  )
}
